export default __webpack_public_path__ + "media/color/rpx-98049b0d.svg";